import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ErrorBoundary } from './app/ErrorBoundary';
import { installClientErrorReporter } from './app/clientErrorReporter';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root not found');
}

installClientErrorReporter();

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
